import { motion } from "framer-motion";
import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';


  const MotionLink = motion.create(Link);
export function CTASection() {

  return (
    <div className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center bg-gradient-to-br from-brand-blue-900 to-brand-blue-800 rounded-3xl p-12 shadow-2xl relative overflow-hidden"
        >
          {/* Background Decoration */}
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 right-0 w-64 h-64 bg-white rounded-full -translate-y-1/2 translate-x-1/2"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-white rounded-full translate-y-1/2 -translate-x-1/2"></div>
          </div>

          {/* Content */}
          <div className="relative z-10">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full text-white text-sm mb-6">
              <Sparkles className="w-4 h-4" />
              <span>Need Guidance?</span>
            </div>

            <h2 className="text-white mb-4">
              Not sure which category to choose?
            </h2>
            <p className="text-white/90 text-lg mb-8 max-w-2xl mx-auto">
              Our expert advisors can help you find the right professional for your needs
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              {/* 🟢 FIXED: Converted motion.button to motion.a and added the one-liner WhatsApp link */}
              <motion.a
                href="https://wa.me/918368832850?text=Hi%20True%20Adviso%20team%2C%20I%20am%20visiting%20your%20website%20and%20need%20some%20guidance."
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="px-8 py-4 bg-white text-brand-blue-900 rounded-full hover:bg-gray-50 transition-colors inline-flex items-center justify-center gap-2 shadow-lg"
              >
                <span>Talk to Team</span>
                <ArrowRight className="w-5 h-5" />
              </motion.a>

             <MotionLink
  to="/experts"
  whileHover={{ scale: 1.05 }}
  whileTap={{ scale: 0.95 }}
  className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white rounded-full hover:bg-white/20 transition-colors border-2 border-white/30 inline-block"
>
  Browse All Experts
</MotionLink>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}